<template>
  <!-- 选择询价商品 -->
  <el-dialog
    title="商品信息"
    :visible.sync="supplierDetailVisible"
    width="800px"
    :before-close="closeSupplierDetailDia"
    :close-on-click-modal="false"
    class="supplier-detail"
    append-to-body
  >
    <div class="list-box">
      <el-table
        ref="tableData"
        v-loading="tabelLoading"
        max-height="445"
        :data="tableData"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column label="序号" width="60px">
          <template #default="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="商品名称" min-width="260" align="center"></el-table-column>
        <el-table-column prop="brandName" label="品牌" min-width="130" align="center"></el-table-column>
        <el-table-column prop="specifications" label="规格型号" min-width="260" align="center"></el-table-column>
        <el-table-column prop="productDescription" label="商品描述" min-width="90" align="center"></el-table-column>
        <el-table-column prop="requiredQuantity" label="需求数量" min-width="80" align="center"></el-table-column>
        <el-table-column prop="unitName" label="计量单位" min-width="80" align="center"></el-table-column>
        <el-table-column prop="price" label="报价单价(含税)" min-width="110" align="center"></el-table-column>
        <el-table-column prop="taxRate" label="税率(%)" min-width="80" align="center"></el-table-column>
        <el-table-column prop="deliveryFee" label="运费(元)" min-width="80" align="center"></el-table-column>
        <el-table-column prop="totalPrice" label="小计" min-width="80" align="center"></el-table-column>
        <el-table-column label="操作" min-width="130" align="center">
          <template #default="slotScope">
            <span
              v-if="
                slotScope.row.enquiryDetailAttachmentList.length &&
                slotScope.row.enquiryDetailAttachmentList[0].attachmentUrl
              "
              class="defalut-table-btn"
              @click="downloadFile(slotScope.row)"
            >
              查看附件
            </span>
            <span class="defalut-table-btn" @click="openRemarkDia(slotScope.row)">备注管理</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="money-box">
        <span>含税总金额：</span>
        <span class="money">¥ {{ offerAmount }}</span>
      </div>
    </div>
    <div slot="footer">
      <eui-btn type="secondary" @click="closeSupplierDetailDia">关闭</eui-btn>
    </div>

    <el-dialog width="36%" title="报价备注管理" :visible.sync="remarkVisible" append-to-body class="remark-box">
      <el-row>
        <el-col :span="4" style="text-align: right; margin-bottom: 10px">
          <span>备注信息：</span>
        </el-col>
        <el-col :span="18">
          <span>
            {{ remarkInfo.attachmentRemark }}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" style="text-align: right">
          <span>描述附件：</span>
        </el-col>
        <el-col :span="18">
          <span v-if="remarkInfo.attachmentUrl" style="cursor: pointer" @click="downloadRemarkFile(remarkInfo)">
            {{ remarkInfo.attachmentName }}
          </span>
        </el-col>
      </el-row>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry';
import EuiBtn from 'epec-ui/src/package/eui-btn/index';

export default {
  components: { EuiBtn },
  props: {
    supplierDetailVisible: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default() {
        return { supplierOfferId: -1, enquiryId: -1 };
      },
    },
    offerAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      remarkInfo: {},
      tabelLoading: false,
      remarkVisible: false,
      listQuery: {
        pageNum: 1,
        pageSize: 100,
      },
      cloneSelectProductsForm: {},
      total: 0,
      tableData: [],
    };
  },
  watch: {
    supplierDetailVisible(oldVal, newVal) {
      if (oldVal) {
        const { listQuery } = this.$options.data();
        this.cloneSelectProductsForm = {
          // ...utils.cloneDeep(this.listQuery)
          ...listQuery,
        };
        console.log(this.cloneSelectProductsForm, this.listQuery, 'this.listQuery');
        const params = { ...this.listQuery, ...this.params };
        console.log(params);
        this.tableData = [];
        this.getList(params);
      }
    },
  },
  methods: {
    downloadRemarkFile(row) {
      const file = row;
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(file.attachmentUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = file.attachmentName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    downloadFile(row) {
      const fileArr = row.enquiryDetailAttachmentList;
      const file = fileArr[0];
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(file.attachmentUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = file.attachmentName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    openRemarkDia(row) {
      const { supplierOfferDetailAttachmentList = [] } = row;
      if (supplierOfferDetailAttachmentList.length) {
        this.remarkInfo = supplierOfferDetailAttachmentList[0];
      }
      console.log(this.remarkInfo);
      this.remarkVisible = true;
    },
    // 获取列表数据
    async getList(params) {
      this.tabelLoading = true;
      await Api.querySupplierOfferDetailPage(params).then((res) => {
        this.tabelLoading = false;
        if (res.code === '200') {
          const { data } = res;
          // this.offerAmount = data.offerAmount;
          this.tableData = [...data?.records];
          console.log(this.tableData, 'this.tableDatathis.tableDatathis.tableData');
          // this.total = res.data?.total;
        }
      });
    },
    closeSupplierDetailDia() {
      this.listQuery = { ...this.cloneSelectProductsForm };
      this.$emit('update:supplierDetailVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.money-box {
  width: 100%;
  text-align: right;
  margin-top: 10px;
  .money {
    color: #f0250f;
  }
}
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束

.supplier-detail {
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      /* .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      } */
    }
  }
  .list-box {
    .defalut-table-btn {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    padding: 0 10px 10px 0;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }

    .default-btn {
      background: #fff;
      border: 1px solid #dcdfe6;
    }
  }
}
</style>
